import React, { useEffect, useRef, useState } from 'react';

/**
 * AdSense Ad Unit - Jobs
 * Display this component on job listing or job detail pages
 * Ad Slot: 2387726629
 */
const AdUnitJobs = () => {
  const adRef = useRef(null);
  const containerRef = useRef(null);
  const isAdPushed = useRef(false);
  const [hasAd, setHasAd] = useState(true); // Start as true, will hide if no ad detected

  useEffect(() => {
    // Ensure adsbygoogle is loaded and ad is pushed only once
    if (window.adsbygoogle && adRef.current && !isAdPushed.current) {
      try {
        window.adsbygoogle.push({});
        isAdPushed.current = true;
      } catch (err) {
        console.error('AdSense error:', err);
      }
    }

    // Check if ad is actually displayed after a delay
    const checkAdDisplay = () => {
      if (adRef.current) {
        const adElement = adRef.current;
        const computedStyle = window.getComputedStyle(adElement);
        
        // Check if ad has been hidden by AdSense (display: none means no ad available)
        const isHidden = computedStyle.display === 'none';
        
        // Check if ad has content (height > 0 or has children with content)
        const hasHeight = adElement.offsetHeight > 0;
        const hasChildren = adElement.children.length > 0;
        
        // Check if children have actual content (not just empty divs)
        let hasRealContent = false;
        if (hasChildren) {
          for (let child of adElement.children) {
            if (child.offsetHeight > 0 || child.textContent.trim().length > 0) {
              hasRealContent = true;
              break;
            }
          }
        }
        
        // Hide if ad is explicitly hidden or has no real content
        if (isHidden || (!hasHeight && !hasRealContent)) {
          setHasAd(false);
        }
      }
    };

    // Check after 3 seconds (ads usually load within this time)
    const timeoutId = setTimeout(checkAdDisplay, 3000);
    
    // Also check after 6 seconds as a fallback
    const fallbackTimeoutId = setTimeout(checkAdDisplay, 6000);

    // Use MutationObserver to detect when ad content is added
    const observer = new MutationObserver(() => {
      checkAdDisplay();
    });

    if (adRef.current) {
      observer.observe(adRef.current, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    return () => {
      clearTimeout(timeoutId);
      clearTimeout(fallbackTimeoutId);
      observer.disconnect();
    };
  }, []);

  // Don't render if no ad is detected
  if (!hasAd) {
    return null;
  }

  return (
    <div 
      ref={containerRef}
      className="ad-container" 
      style={{ margin: '20px 0', textAlign: 'center' }}
    >
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-6685427806563315"
        data-ad-slot="2387726629"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdUnitJobs;
